import React, { useCallback } from 'react';
import cn from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { enhance } from './enhance';
import Button from '../../../Button';
import Popup from '../../../common/Popup';
import { INSURANCE_ERROR_CODES } from '../../../../constants/errors';
import { INSURANCE_FLOW_TYPE } from '../../../../constants/insurance-flow-type';
import { makeInsuranceErrorMessage } from '../../../../utils/appointments/makeInsuranceErrorMessage';
import { insuranceErrorModalActions } from '../../../../redux/appointmentForm/handle-insurance-error-modal';
import { manageInsurancesActions } from '../../../../redux/manage-insurances/actions/manage-insurances-actions';
import styles from './index.styl';

function HandleErrorCheckProfileInsuranceModal({
  entity,
  error,
  finishAction,
  flowType,
  handleSave,
  isOpened,
  skipInsurance,
  userId,
}) {
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();

  const { errors, insuranceEligibilityResultId: id } = { ...entity };

  const code = get(error, 'code');

  const { title, message } = useCallback(
    makeInsuranceErrorMessage(code, formatMessage),
    [code],
  );

  const isInsuranceRequestFailed =
    code === INSURANCE_ERROR_CODES.INSURANCE_REQUEST_FAILED;

  const isCopayNotReceived = code === INSURANCE_ERROR_CODES.COPAY_NOT_RECEIVED;

  const isToDoFlow = flowType === INSURANCE_FLOW_TYPE.TO_DO;

  const handleCloseModal = () => {
    dispatch(insuranceErrorModalActions.close());
  };

  const handleSaveAnyway = () => {
    if (isToDoFlow) {
      handleSave(true);
    } else {
      const requestData = {
        userId,
        insuranceEligibilityResultId: id,
        skipInsurance,
        finishAction,
        flowType,
      };

      dispatch(
        manageInsurancesActions.runManualEligibilityActivation(requestData),
      );
    }
  };

  return (
    <Popup
      opened={isOpened}
      withHeading={false}
      mobileFullScreen={false}
      onClose={handleCloseModal}
    >
      <div className={styles.root}>
        <div className={styles.title}>{title}</div>
        <div
          className={cn(styles.message, {
            [styles.textCenter]: !errors || isCopayNotReceived,
          })}
        >
          {message}
        </div>
        {errors &&
          isInsuranceRequestFailed &&
          errors.length > 0 &&
          errors.map(item => (
            <div className={styles.error} key={item}>{`- ${item}`}</div>
          ))}

        <div className={styles.actionButtonWrapper}>
          <Button
            raised
            color="primary"
            className={styles.button}
            onClick={handleSaveAnyway}
          >
            {formatMessage({ id: 'common.saveAnyway' })}
          </Button>
          <Button
            raised
            color="accent"
            className={styles.button}
            onClick={handleCloseModal}
          >
            {formatMessage({ id: 'common.cancel' })}
          </Button>
        </div>
      </div>
    </Popup>
  );
}

HandleErrorCheckProfileInsuranceModal.propTypes = {
  entity: PropTypes.object,
  error: PropTypes.object,
  finishAction: PropTypes.func,
  flowType: PropTypes.string,
  handleSave: PropTypes.func,
  isOpened: PropTypes.bool,
  skipInsurance: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default enhance(HandleErrorCheckProfileInsuranceModal);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/HandleErrorCheckProfileInsuranceModal/index.jsx